import { Box, BoxProps, CheckBox, TextNew } from '@jfs/ui-new'
import React, { FC, useEffect, useState } from 'react'
import { Colors } from '../../../../util/util'
import { CheckBoxIcon } from './CheckBoxIcon'

interface AcessRightsCheckboxProps {
  heading: string
  initialCheckBoxData: { permissionCode: string; isChecked: boolean }[]
  fieldName: string
  setFieldValue: (fieldName: string, val: any) => void
  expandView: boolean
  onSelect: (val: any) => void
  role: any
  isEditScreen?: boolean
  allEditable?: boolean
}

const RenderItem = ({ item, checkBoxData, updateCheckBoxData, onSelect, isAllChecked, evaluateAllChecked }: any) => {
  return (
    <Box {...styles.itemContainer} key={item.item?.permissionId}>
      <CheckBox
        checked={item.item?.isChecked ?? false}
        onChange={() => {
          const updatedCheckBoxData = checkBoxData.map((data: any) => {
            if (data.permissionCode === item.item.permissionCode) {
              data.isChecked = !data.isChecked
            }
            return data
          })
          updateCheckBoxData(updatedCheckBoxData)
          const isChecked = isAllChecked()
          onSelect(isChecked)
          evaluateAllChecked()
        }}
        iconSize={20}
        color={item.item?.isChecked ? 'PRIMARY' : 'PRIMARY_GREY'}
      />
      <TextNew fontSize={12} color="PRIMARY_GREY" fontFamily="JioType-Medium">
        {item.item.permissionDesc ?? item.item?.permissionCode}
      </TextNew>
    </Box>
  )
}

export const AcessRightsCheckbox: FC<AcessRightsCheckboxProps> = ({
  heading,
  initialCheckBoxData,
  setFieldValue,
  fieldName,
  expandView,
  onSelect,
  role,
  isEditScreen,
  allEditable,
}: AcessRightsCheckboxProps) => {
  const [checkBoxData, updateCheckBoxData] = React.useState(JSON.parse(JSON.stringify(initialCheckBoxData)))

  useEffect(() => {
    setFieldValue(fieldName, checkBoxData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkBoxData])

  const isReadOnly = () => {
    return (
      checkBoxData.filter((item: any) => {
        return item?.readOnly
      }).length === checkBoxData.length
    )
  }

  const evaluateAllChecked = () => {
    const checkedItems = checkBoxData.filter((item: any) => {
      return item?.isChecked
    })
    const readOnlyItems = isReadOnly()
    // debugger
    if (isEditScreen) {
      if (checkedItems?.length === 0) {
        return 'CheckboxOff'
      } else if (checkedItems?.length === checkBoxData.length) {
        return 'CheckboxOn'
      } else {
        return 'CheckboxOff'
      }
    } else if (role !== 'Other') {
      if (readOnlyItems && checkedItems?.length === checkBoxData.length) {
        return 'ItemChecked'
      } else if (!readOnlyItems && checkedItems?.length === 0) {
        return 'ItemUnChecked'
      } else if (checkedItems?.length === checkBoxData.length) {
        return 'ItemChecked'
      } else {
        return 'ItemUnChecked'
      }
    } else {
      if (checkedItems?.length === 0) {
        return 'CheckboxOff'
      } else if (checkedItems?.length === checkBoxData.length) {
        return 'CheckboxOn'
      } else {
        return 'CheckboxOff'
      }
    }
  }

  const isAllChecked = () => {
    return (
      checkBoxData.filter((item: any) => {
        return !item?.isChecked
      }).length === 0
    )
  }
  const [showChild, setShowChild] = useState(expandView)
  const toggleAll = () => {
    if (isEditScreen || role === 'Other') {
      const isChecked = isAllChecked()
      const updatedCheckBoxData = checkBoxData.map((data: any) => {
        data.isChecked = !isChecked
        return data
      })
      setShowChild(false)
      updateCheckBoxData(updatedCheckBoxData)
      onSelect(isAllChecked())
    }
  }

  const isItemDisabled = isEditScreen ? false : isReadOnly()
  console.log('isEditScreen', role, isEditScreen, isItemDisabled)

  return (
    <Box flex={1} alignItems="flex-start" justifyContent="space-between" flexWrap={'wrap'}>
      <Box {...styles.parent} testID="show-access-rights" onPress={() => setShowChild(false)}>
        <CheckBoxIcon
          header={heading}
          toggleAll={toggleAll}
          size={20}
          fontType={evaluateAllChecked()}
          color={isItemDisabled && role !== 'Admin' ? Colors.GREY_BG : '#00B259'}
          role={role}
          disabled={isItemDisabled}
        />
      </Box>
      {showChild && (
        <Box>
          {checkBoxData?.map((data: any) => (
            <RenderItem
              item={{ item: data }}
              checkBoxData={checkBoxData}
              updateCheckBoxData={updateCheckBoxData}
              onSelect={onSelect}
              isAllChecked={isAllChecked}
              evaluateAllChecked={evaluateAllChecked}
            />
          ))}
          {/* <FlatList data={checkBoxData} renderItem={_renderItem} keyExtractor={(item: any) => item.permissionId} /> */}
        </Box>
      )}
    </Box>
  )
}

const styles = {
  parent: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  itemContainer: {
    paddingLeft: 24,
    height: 48,
    flexDirection: 'row',
    alignItems: 'center',
  } as BoxProps,
}
